import { Dialog } from "@material-ui/core";
import { GoogleOAuthProvider } from "@react-oauth/google";
import axios from "axios";
import React, { useEffect, useMemo, useState } from "react";
import BlockUi from "react-block-ui";
import { AiOutlineCloseCircle } from "react-icons/ai";
import { FaEye, FaEyeSlash, FaRegUser } from "react-icons/fa";
import { MdOutlineMail } from "react-icons/md";
import PhoneInput from "react-phone-input-2";
import { useDispatch, useSelector } from "react-redux";
import { withRouter } from "react-router-dom";
import Select from "react-select";
import { toast } from "react-toastify";
import Swal from "sweetalert2";
import LoginService from "../../../api/LoginService";
import { API_URL } from "../../../config/app-config";
import {
  CLIENT_ID,
  GOOGLE_CLIENT_ID,
  KEY_CLOAK_URL,
} from "../../../config/keycloak-config";
import Phone from "../../../images/SocialMediaGif/telephone.png";
import { getAllCountryName } from "../../../redux/actions/commonApiActions";
import {
  getUserDetailsByToken,
  keyCloakLoader,
  loginErrorUpdate,
  mobileNumberRegister,
  registerErrorUpdate,
  socialKeyClockLoginAction,
  updateKeyCloakToken,
} from "../../../redux/actions/loginDetailsActions";
import { language } from "../../../sampleData/Options";
import { getLocalStorage, isValidEmail, passwordCheck } from "../../../utils";
import GoogleLogin from "../../Login/LoginV2/GoogleLogin";
import OtpInput from "../../Login/LoginV2/OtpInput";
import { dBody, dropFlowStyle } from "../../../components/Utils";

/* ─── Design Tokens ──────────────────────────────────────────────────────── */
const T = {
  crimson:   "#b91c38",
  crimsonDk: "#8b1228",
  crimsonXl: "#fdf2f4",
  crimsonRim: "#f5d0d8",
  ink:       "#0c0608",
  inkMid:    "#3a1a22",
  muted:     "#9a7a82",
  border:    "#ede8e9",
  surface:   "#fefcfc",
  white:     "#ffffff",
};

/* ─── Inject Styles ──────────────────────────────────────────────────────── */
function StyleInjector() {
  useEffect(() => {
    if (document.querySelector("#slm-v3-styles")) return;
    const el = document.createElement("style");
    el.id = "slm-v3-styles";
    el.textContent = `
 
      .slm-root * { box-sizing: border-box; }

      /* Paper */
      .slm-paper {
        border-radius: 24px !important;
        overflow: hidden !important;
        box-shadow: 0 32px 100px rgba(0,0,0,0.22) !important;
        border: 1px solid rgba(255,255,255,0.06) !important;
        max-width: 520px !important;
        width: 100% !important;
      }

      /* Backdrop */
      .slm-backdrop {
        background: rgba(8,3,4,0.6) !important;
        backdrop-filter: blur(10px) !important;
      }

      /* Shell */
      .slm-shell {
        display: flex;
        flex-direction: column;
        background: ${T.white};
        min-height: 560px;
        position: relative;
        font-family: 'DM Sans', sans-serif;
      }

      /* Header band */
      .slm-header {
        background: ${T.ink};
        padding: 2.2rem 2.5rem 1.8rem;
        position: relative;
        overflow: hidden;
      }
      .slm-header::before {
        content: '';
        position: absolute;
        inset: 0;
        background:
          radial-gradient(ellipse 380px 220px at 110% -10%, rgba(185,28,56,0.22) 0%, transparent 70%),
          radial-gradient(ellipse 260px 200px at -20% 120%, rgba(185,28,56,0.12) 0%, transparent 70%);
        pointer-events: none;
      }

      /* Grid lines */
      .slm-grid {
        position: absolute;
        inset: 0;
        background-image:
          linear-gradient(rgba(255,255,255,0.03) 1px, transparent 1px),
          linear-gradient(90deg, rgba(255,255,255,0.03) 1px, transparent 1px);
        background-size: 28px 28px;
        pointer-events: none;
      }

      /* Pill badge */
      .slm-pill {
        display: inline-flex;
        align-items: center;
        gap: 6px;
        background: rgba(185,28,56,0.18);
        border: 1px solid rgba(185,28,56,0.35);
        color: #f0a0b0;
        border-radius: 100px;
        padding: 4px 12px;
        font-size: 0.65rem;
        font-weight: 600;
        letter-spacing: 0.1em;
        text-transform: uppercase;
        margin-bottom: 0.9rem;
      }
      .slm-pill-dot {
        width: 5px;
        height: 5px;
        border-radius: 50%;
        background: ${T.crimson};
        animation: slm-pulse 2s ease infinite;
      }
      @keyframes slm-pulse {
        0%, 100% { opacity: 1; }
        50% { opacity: 0.35; }
      }

      .slm-h1 {
        font-family: 'Cormorant Garamond', Georgia, serif;
        font-size: 2.1rem;
        font-weight: 700;
        color: ${T.white};
        line-height: 1.1;
        letter-spacing: -0.5px;
        margin: 0 0 0.35rem;
        position: relative;
      }
      .slm-h1 em {
        font-style: italic;
        color: #f0a0b0;
      }
      .slm-sub {
        font-size: 0.8rem;
        color: rgba(255,255,255,0.38);
        margin: 0;
        position: relative;
      }

      /* Close */
      .slm-close {
        position: absolute;
        top: 1.1rem;
        right: 1.2rem;
        cursor: pointer;
        color: rgba(255,255,255,0.28);
        font-size: 1.3rem;
        transition: color 0.2s;
        z-index: 10;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 30px;
        height: 30px;
        border-radius: 50%;
        background: rgba(255,255,255,0.06);
        border: 1px solid rgba(255,255,255,0.08);
      }
      .slm-close:hover { color: ${T.white}; background: rgba(255,255,255,0.1); }

      /* Body */
      .slm-body {
        flex: 1;
        padding: 2rem 2.5rem 2rem;
        display: flex;
        flex-direction: column;
        justify-content: center;
      }

      /* Label */
      .slm-lbl {
        display: block;
        font-size: 0.65rem;
        font-weight: 600;
        color: ${T.muted};
        letter-spacing: 0.09em;
        text-transform: uppercase;
        margin-bottom: 0.3rem;
      }

      /* Input wrap */
      .slm-inp-wrap {
        position: relative;
        margin-bottom: 1rem;
      }
      .slm-inp {
        width: 100%;
        height: 46px;
        padding: 0 1rem 0 2.6rem;
        border-radius: 11px;
        border: 1.5px solid ${T.border};
        background: ${T.surface};
        font-size: 0.875rem;
        font-family: 'DM Sans', sans-serif;
        color: ${T.ink};
        outline: none;
        transition: border-color 0.18s, box-shadow 0.18s;
      }
      .slm-inp:focus {
        border-color: ${T.crimson};
        box-shadow: 0 0 0 3px rgba(185,28,56,0.1);
        background: ${T.white};
      }
      .slm-inp::placeholder { color: #d0b8bc; }
      .slm-inp-icon {
        position: absolute;
        left: 0.85rem;
        top: 50%;
        transform: translateY(-50%);
        color: #d8b8be;
        font-size: 13px;
        pointer-events: none;
        display: flex;
        align-items: center;
      }
      .slm-inp-icon-r {
        position: absolute;
        right: 0.85rem;
        top: 50%;
        transform: translateY(-50%);
        color: #d0b0b8;
        cursor: pointer;
        display: flex;
        align-items: center;
      }

      /* Primary button */
      .slm-btn-primary {
        width: 100%;
        height: 48px;
        border-radius: 11px;
        background: ${T.crimson};
        color: ${T.white};
        font-family: 'DM Sans', sans-serif;
        font-weight: 600;
        font-size: 0.9rem;
        border: none;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 8px;
        letter-spacing: 0.01em;
        box-shadow: 0 1px 0 ${T.crimsonDk}, 0 4px 16px rgba(185,28,56,0.3);
        transition: background 0.15s, transform 0.1s, box-shadow 0.15s;
        margin-top: 0.25rem;
      }
      .slm-btn-primary:hover {
        background: ${T.crimsonDk};
        box-shadow: 0 1px 0 #6b0a1c, 0 6px 20px rgba(185,28,56,0.38);
        transform: translateY(-1px);
      }
      .slm-btn-primary:active { transform: translateY(0); }

      /* Divider */
      .slm-divider {
        display: flex;
        align-items: center;
        gap: 0.7rem;
        margin: 1.1rem 0;
      }
      .slm-divider-line { flex: 1; height: 1px; background: ${T.border}; }
      .slm-divider-txt { font-size: 0.7rem; color: #c8b0b4; letter-spacing: 0.04em; }

      /* Social button */
      .slm-btn-social {
        width: 100%;
        height: 44px;
        border-radius: 11px;
        border: 1.5px solid ${T.border};
        background: ${T.white};
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 9px;
        cursor: pointer;
        font-size: 0.85rem;
        font-family: 'DM Sans', sans-serif;
        color: ${T.inkMid};
        font-weight: 500;
        transition: border-color 0.15s, box-shadow 0.15s, background 0.15s;
        box-shadow: 0 1px 2px rgba(0,0,0,0.04);
        margin-bottom: 0.55rem;
      }
      .slm-btn-social:hover {
        border-color: ${T.crimsonRim};
        background: ${T.crimsonXl};
        box-shadow: 0 2px 10px rgba(185,28,56,0.08);
      }

      /* Footer text */
      .slm-footer-txt {
        text-align: center;
        font-size: 0.8rem;
        color: ${T.muted};
        margin-top: 1rem;
      }
      .slm-link {
        color: ${T.crimson};
        font-weight: 600;
        cursor: pointer;
        text-decoration: none;
      }
      .slm-link:hover { text-decoration: underline; }

      /* Forgot */
      .slm-forgot {
        display: block;
        text-align: right;
        font-size: 0.74rem;
        color: ${T.crimson};
        font-weight: 500;
        cursor: pointer;
        margin-top: -0.55rem;
        margin-bottom: 1rem;
      }

      /* OTP screen */
      .slm-otp-screen {
        display: flex;
        flex-direction: column;
        align-items: center;
        text-align: center;
        gap: 0.9rem;
        padding: 0.5rem 0 0.5rem;
      }
      .slm-otp-icon {
        width: 60px;
        height: 60px;
        border-radius: 50%;
        background: ${T.crimsonXl};
        border: 1.5px solid ${T.crimsonRim};
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 1.6rem;
        margin-bottom: 0.25rem;
      }
      .slm-otp-hl {
        font-family: 'Cormorant Garamond', serif;
        font-size: 1.7rem;
        font-weight: 700;
        color: ${T.ink};
        margin: 0;
        line-height: 1.1;
      }
      .slm-otp-sub {
        font-size: 0.83rem;
        color: ${T.muted};
        margin: 0;
      }
      .slm-phone-hl { color: ${T.crimson}; font-weight: 700; }

      /* Phone input override */
      .slm-phone .react-tel-input .form-control {
        height: 46px !important;
        border-radius: 0 11px 11px 0 !important;
        border: 1.5px solid ${T.border} !important;
        background: ${T.surface} !important;
        font-family: 'DM Sans', sans-serif !important;
        font-size: 0.875rem !important;
        color: ${T.ink} !important;
        width: 100% !important;
        box-shadow: none !important;
      }
      .slm-phone .react-tel-input .form-control:focus {
        border-color: ${T.crimson} !important;
        box-shadow: 0 0 0 3px rgba(185,28,56,0.1) !important;
      }
      .slm-phone .react-tel-input .flag-dropdown {
        border: 1.5px solid ${T.border} !important;
        border-right: none !important;
        border-radius: 11px 0 0 11px !important;
        background: ${T.surface} !important;
      }
      .slm-phone .react-tel-input .flag-dropdown:hover,
      .slm-phone .react-tel-input .flag-dropdown.open { background: ${T.crimsonXl} !important; }
    `;
    document.head.appendChild(el);
  }, []);
  return null;
}

/* ─── Select custom styles ───────────────────────────────────────────────── */
const selectStyles = {
  control: (b, s) => ({
    ...b,
    borderRadius: 11,
    border: `1.5px solid ${s.isFocused ? T.crimson : T.border}`,
    background: T.surface,
    boxShadow: s.isFocused ? `0 0 0 3px rgba(185,28,56,0.1)` : "none",
    fontFamily: "'DM Sans', sans-serif",
    fontSize: "0.875rem",
    minHeight: 46,
    marginBottom: "1rem",
    cursor: "pointer",
  }),
  option: (b, s) => ({
    ...b,
    background: s.isSelected ? T.crimson : s.isFocused ? T.crimsonXl : T.white,
    color: s.isSelected ? T.white : T.ink,
    fontFamily: "'DM Sans', sans-serif",
    fontSize: "0.875rem",
  }),
  placeholder: (b) => ({ ...b, color: "#d0b8bc" }),
  singleValue: (b) => ({ ...b, color: T.ink }),
  indicatorSeparator: () => ({ display: "none" }),
};

/* ─── Arrow icon ─────────────────────────────────────────────────────────── */
const Arrow = () => (
  <svg width="15" height="15" viewBox="0 0 16 16" fill="none">
    <path d="M3 8h10M9 4l4 4-4 4" stroke="white" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

/* ─── Premium Input ──────────────────────────────────────────────────────── */
function Inp({ icon, rightIcon, onRightClick, ...props }) {
  return (
    <div className="slm-inp-wrap">
      {icon && <span className="slm-inp-icon">{icon}</span>}
      <input
        className="slm-inp"
        style={{ paddingLeft: icon ? "2.5rem" : "1rem", paddingRight: rightIcon ? "2.5rem" : "1rem" }}
        {...props}
      />
      {rightIcon && (
        <span className="slm-inp-icon-r" onClick={onRightClick}>{rightIcon}</span>
      )}
    </div>
  );
}

/* ─── Header ─────────────────────────────────────────────────────────────── */
function Header({ title, italicTitle, sub, onClose, pill }) {
  return (
    <div className="slm-header">
      <div className="slm-grid" />
      <button className="slm-close" onClick={onClose} type="button" aria-label="Close">
        <AiOutlineCloseCircle size={18} />
      </button>
      <div className="slm-pill">
        <span className="slm-pill-dot" />
        {pill}
      </div>
      <h2 className="slm-h1">
        {title} {italicTitle && <em>{italicTitle}</em>}
      </h2>
      <p className="slm-sub">{sub}</p>
    </div>
  );
}

/* ─── Main Component ─────────────────────────────────────────────────────── */
function ServiceLoginModel(props) {
  const dispatch = useDispatch();

  const [state, setState] = useState({
    screen: "login",
    email: "",
    password: "",
    firstName: "",
    lastName: "",
    confirmPassword: "",
    inputType: "password",
    cInputType: "password",
    forgot: false,
    name: "",
    country: "",
    phoneNumber: "",
    menu: 0,
    countryList: [],
    otp: "",
    signInStatus: "",
    onResentOtp: false,
    language: { label: "English", value: "English" },
    isLoginScreen: false,
  });

  const countryList     = useSelector((s) => s.commonApi.countryName);
  const {
    loginLoader, loginError, userLoggedIn, loginUserError,
    loginDetails, registerErrorStatus, loginErrorMessage,
  } = useSelector((s) => s.loginDetailsApi);

  const update = (name, value) => setState((p) => ({ ...p, [name]: value }));

  useEffect(() => {
    if (countryList.length > 0 && state.countryList?.length === 0) {
      update("countryList", countryList.map((i) => ({ value: i.iso, label: i.nicename, id: i.id })));
    }
  }, [countryList, state]);

  useEffect(() => {
    dispatch(keyCloakLoader(false));
    dispatch(getAllCountryName());
    const token = getLocalStorage("R_TOKEN");
    if (!userLoggedIn && token) dispatch(getUserDetailsByToken({ token, client_id: CLIENT_ID }));
  }, []);

  useEffect(() => {
    if (userLoggedIn) {
      props.history.push(`/${loginDetails?.defaultWorkSpace || "default"}/home`);
    }
    if (loginError) {
      props.closeModel();
      Swal.fire({
        icon: "error", title: "Oops...",
        text: loginUserError === "blocked_by_admin"
          ? "Your login has been blocked by the admin."
          : loginErrorMessage || "Something went wrong.",
      });
      dispatch(loginErrorUpdate(false));
    }
    if (registerErrorStatus) {
      props.closeModel();
      Swal.fire({ icon: "error", title: "Oops...", text: `${registerErrorStatus || "Something went wrong."}` });
      dispatch(registerErrorUpdate(null));
    }
  }, [loginError, userLoggedIn, registerErrorStatus]);

  const updateToken = (type, token) => {
    if (token?.access_token) dispatch(socialKeyClockLoginAction(type, token.access_token));
    else errorGettingToken(type, token);
  };
  const errorGettingToken = (type, e) => {
    console.error(`Error getting ${type} token:`, e);
    Swal.fire({ icon: "error", title: "Oops...", text: "Social login failed." });
  };

  const submitForm = (e, resend) => {
    e.preventDefault(); e.stopPropagation();
    if (!state.country?.value && state.screen !== "mobile-signIn") return toast.warning("Select your country");
    if (state.phoneNumber.length <= 8 || state.phoneNumber.length >= 16) return toast.warning("Enter valid phone number");
    dispatch(keyCloakLoader(true));
    const data = { phoneNumber: state.phoneNumber };
    if (state.screen === "mobile-signIn") {
      LoginService.phoneExitCheck(data).then((res) => {
        if (res.data.data === "PHONE_NUMBER_EXIST") loginOtpSend(resend);
        else Swal.fire({
          title: "Phone number not found", showCancelButton: true,
          confirmButtonText: "Create New Account", cancelButtonText: "Re-enter Number",
          reverseButtons: true, icon: "warning",
        }).then((r) => { if (r.value) update("screen", "register"); });
        dispatch(keyCloakLoader(false));
      }).catch(() => dispatch(keyCloakLoader(false)));
    } else {
      if (state.email) data.email = state.email;
      LoginService.generateOtp(data).then((res) => {
        if (res.data.data === "OTP_SENT") {
          update("screen", "otp");
          if (resend) update("onResentOtp", !state.onResentOtp);
        } else if (res.data.data === "PHONE_NUMBER_ALREADY_REGISTERED") toast.error("Mobile number already registered.");
        else if (res.data.data === "EMAIL_ALREADY_EXIST") toast.error("Email already in use.");
        else toast.error("Something went wrong.");
        dispatch(keyCloakLoader(false));
      }).catch(() => dispatch(keyCloakLoader(false)));
    }
  };

  const loginOtpSend = (resend) => {
    axios.post(`${KEY_CLOAK_URL}realms/yuukke/sms-authentication/otp/${state.phoneNumber}`)
      .then(() => { dispatch(keyCloakLoader(false)); update("screen", "otp"); if (resend) update("onResentOtp", !state.onResentOtp); })
      .catch(() => { update("screen", "otp"); dispatch(keyCloakLoader(false)); if (resend) update("onResentOtp", !state.onResentOtp); });
  };

  const verifyOtp = () => {
    if (state.otp?.length === 6 && state.isLoginScreen) {
      dispatch(keyCloakLoader(true));
      LoginService.validateLoginOtp({ mobile_number: state.phoneNumber, otp: state.otp, client_id: CLIENT_ID })
        .then((res) => {
          if (res.data?.access_token) dispatch(updateKeyCloakToken(res.data));
          else { toast.error("Invalid OTP."); dispatch(keyCloakLoader(false)); }
        }).catch(() => { dispatch(keyCloakLoader(false)); toast.error("Invalid OTP."); });
    } else if (state.otp?.length === 6 && state.screen !== "mobile-signIn") {
      dispatch(keyCloakLoader(true));
      LoginService.validateOtp({ phoneNumber: state.phoneNumber, otp: state.otp })
        .then((res) => {
          if (res.data.data === "VALID_OTP") {
            dispatch(mobileNumberRegister(
              { name: state.name, phoneNumber: state.phoneNumber, clientId: CLIENT_ID, location: state.country.label, email: state.email },
              { countryId: state.country.id, personalLanguage: state.language.value, country: state.country.label }
            ));
          } else { toast.error("Invalid OTP."); dispatch(keyCloakLoader(false)); }
        }).catch(() => { dispatch(keyCloakLoader(false)); toast.error("Something went wrong."); });
    } else toast.warning("Please enter a valid 6-digit OTP.");
  };

  const previewPhone = useMemo(() => {
    if (!state.phoneNumber) return "";
    return state.phoneNumber.slice(0, -4) + "****";
  }, [state.phoneNumber]);

  const submitFormEmail = (e, listener) => {
    if (!listener) { e.preventDefault(); e.stopPropagation(); }
    if (!state.email.trim() || (state.password.length < 5 && !state.forgot))
      return toast.warning(!state.email ? "Enter valid email" : "Enter valid password");
    if (!isValidEmail(state.email)) return toast.warning("Enter valid email");
    if (state.forgot) {
      dispatch(keyCloakLoader(true));
      LoginService.forgotPassword({ uuid: state.email, action: "UPDATE_PASSWORD" }).then(() => {}).catch(() => {});
      return;
    }
    if (state.screen === "register") {
      if (!state.firstName.trim() || !state.lastName.trim())
        return toast.warning(!state.firstName ? "Enter first name" : "Enter last name");
      if (!state.password || !state.confirmPassword)
        return toast.warning(!state.password ? "Enter password" : "Enter confirm password");
      if (state.password !== state.confirmPassword) return toast.warning("Passwords do not match");
      if (!passwordCheck(state.password)) return toast.warn("Password must be 8+ chars with uppercase, lowercase, number and special char.");
      dispatch(keyCloakLoader(true));
      const request = {
        username: state.email.trim(), firstName: state.firstName.trim(), enabled: true,
        emailVerified: false, totp: false, lastName: state.lastName.trim(),
        email: state.email.trim().toLowerCase(), requiredActions: ["VERIFY_EMAIL"],
        credentials: [{ type: "password", value: state.password.trim() }],
      };
      LoginService.keyClockCreateUser(request).then((res) => {
        dispatch(keyCloakLoader(false));
        if (res.data.data !== 1) toast.error("User already exists.");
      }).catch(() => { toast.error("User already exists."); dispatch(keyCloakLoader(false)); });
    } else {
      dispatch(keyCloakLoader(true));
      const params = new URLSearchParams();
      params.append("grant_type", "password"); params.append("client_id", CLIENT_ID);
      params.append("client_secret", "34471d72-6ade-4959-af93-67fa7760e64c");
      params.append("username", state.email.trim()); params.append("password", state.password.trim());
      axios.post(`${KEY_CLOAK_URL}realms/yuukke/protocol/openid-connect/token`, params, { headers: { "Content-Type": "application/x-www-form-urlencoded" } })
        .then((res) => {
          if (res.data?.access_token) dispatch(updateKeyCloakToken(res.data));
          else Swal.fire({
            title: "Invalid credentials", showCancelButton: true,
            confirmButtonText: "Create Account", cancelButtonText: "Try Again",
            reverseButtons: true, icon: "warning",
          }).then(() => { update("password", ""); dispatch(keyCloakLoader(false)); });
        }).catch((err) => {
          update("password", "");
          dispatch(keyCloakLoader(false));
          if (err?.message === "Network Error") toast.error("Network issue.");
          else if (err?.response?.data?.error_description === "Account disabled") toast.error("Account disabled.");
          else toast.error("Invalid credentials.");
        });
    }
  };

  /* ─── Screens ──────────────────────────────────────────────────────────── */

  const screenLogin = (
    <>
      <Header
        pill="Welcome back"
        title="Sign in to"
        italicTitle="Yuukke"
        sub="Continue building your business"
        onClose={props.closeModel}
      />
      <div className="slm-body">
        <form onSubmit={(e) => submitFormEmail(e, false)}>
          <label className="slm-lbl">Email address</label>
          <Inp icon={<MdOutlineMail />} type="email" placeholder="you@example.com" value={state.email} required onChange={(e) => update("email", e.target.value)} />

          <label className="slm-lbl">Password</label>
          <Inp
            icon={<FaEyeSlash style={{ opacity: 0.5 }} />}
            type={state.inputType} placeholder="Enter password" value={state.password} required
            onChange={(e) => update("password", e.target.value)}
            rightIcon={state.inputType === "password" ? <FaEyeSlash /> : <FaEye />}
            onRightClick={() => update("inputType", state.inputType === "password" ? "text" : "password")}
          />
          <span className="slm-forgot" onClick={() => update("forgot", true)}>Forgot password?</span>

          <button type="submit" className="slm-btn-primary">Sign in <Arrow /></button>

          <div className="slm-divider">
            <div className="slm-divider-line" />
            <span className="slm-divider-txt">or continue with</span>
            <div className="slm-divider-line" />
          </div>

          <button type="button" className="slm-btn-social" onClick={() => setState((p) => ({ ...p, isLoginScreen: true, screen: "mobile-signIn" }))}>
            <img src={Phone} alt="" style={{ width: 17, height: 17 }} />
            Mobile number
          </button>

          <div className="slm-btn-social" style={{ cursor: "default" }}>
            <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
              <GoogleLogin outer={false} updateToken={updateToken} errorGettingToken={errorGettingToken} title="Google account" />
            </GoogleOAuthProvider>
          </div>

          <p className="slm-footer-txt">
            New to Yuukke?{" "}
            <span className="slm-link" onClick={() => setState((p) => ({ ...p, isLoginScreen: false, screen: "register" }))}>
              Create account →
            </span>
          </p>
        </form>
      </div>
    </>
  );

  const screenMobileSignIn = (
    <>
      <Header
        pill="Mobile sign-in"
        title="Enter your"
        italicTitle="number"
        sub="We'll send a one-time code to verify"
        onClose={props.closeModel}
      />
      <div className="slm-body">
        <label className="slm-lbl">Phone number</label>
        <div className="slm-phone" style={{ marginBottom: "1.25rem" }}>
          <PhoneInput country="in" value={state.phoneNumber} onChange={(p) => update("phoneNumber", p)} countryCodeEditable={false} />
        </div>

        <button className="slm-btn-primary" onClick={(e) => submitForm(e, false)}>
          Send OTP <Arrow />
        </button>

        <p className="slm-footer-txt" style={{ marginTop: "1rem" }}>
          <span className="slm-link" onClick={() => setState((p) => ({ ...p, screen: "login", isLoginScreen: false }))}>
            ← Back to email sign-in
          </span>
        </p>
      </div>
    </>
  );

  const screenOtp = (
    <>
      <Header
        pill="Verification"
        title="Check your"
        italicTitle="phone"
        sub={`Code sent to ${previewPhone}`}
        onClose={props.closeModel}
      />
      <div className="slm-body">
        <div className="slm-otp-screen">
          <div className="slm-otp-icon">🔐</div>
          <p className="slm-otp-hl">Enter the 6-digit code</p>
          <p className="slm-otp-sub">
            Sent to <span className="slm-phone-hl">{previewPhone}</span>
          </p>
          <OtpInput length={6} onOtpSubmit={(otp) => update("otp", otp)} />
          <button className="slm-btn-primary" onClick={verifyOtp} style={{ marginTop: "0.5rem" }}>
            Verify & continue <Arrow />
          </button>
          <p className="slm-footer-txt">
            Didn't receive it?{" "}
            <span className="slm-link" onClick={(e) => submitForm(e, true)}>Resend code</span>
          </p>
        </div>
      </div>
    </>
  );

  const screenRegister = (
    <>
      <Header
        pill="Create account"
        title="Join"
        italicTitle="Yuukke"
        sub="Start your entrepreneurial journey today"
        onClose={props.closeModel}
      />
      <div className="slm-body">
        <form onSubmit={(e) => submitForm(e, false)}>
          <label className="slm-lbl">Full name</label>
          <Inp icon={<FaRegUser />} type="text" placeholder="Your name" value={state.name} required onChange={(e) => update("name", e.target.value)} />

          <label className="slm-lbl">Country</label>
          <Select onChange={(e) => update("country", e)} options={state.countryList} value={state.country} placeholder="Select country" styles={selectStyles} menuPortalTarget={dBody} />

          <label className="slm-lbl">Language</label>
          <Select onChange={(e) => update("language", e)} options={language} value={state.language} placeholder="Select language" styles={selectStyles} menuPortalTarget={dBody} />

          <label className="slm-lbl">Email</label>
          <Inp icon={<MdOutlineMail />} type="email" placeholder="you@example.com" value={state.email} required onChange={(e) => update("email", e.target.value)} />

          <label className="slm-lbl">Mobile number</label>
          <div className="slm-phone" style={{ marginBottom: "1.25rem" }}>
            <PhoneInput country="in" value={state.phoneNumber} onChange={(p) => update("phoneNumber", p)} countryCodeEditable={false} />
          </div>

          <button type="submit" className="slm-btn-primary">Continue <Arrow /></button>

          <p className="slm-footer-txt">
            Already have an account?{" "}
            <span className="slm-link" onClick={() => setState((p) => ({ ...p, screen: "login", isLoginScreen: false }))}>
              Sign in →
            </span>
          </p>
        </form>
      </div>
    </>
  );

  const screens = {
    login:          screenLogin,
    "mobile-signIn": screenMobileSignIn,
    otp:            screenOtp,
    register:       screenRegister,
  };

  return (
    <>
      <StyleInjector />
      <Dialog
        open={true}
        onClose={props.closeModel}
        maxWidth="xs"
        fullWidth
        PaperProps={{ className: "slm-paper" }}
        BackdropProps={{ className: "slm-backdrop" }}
      >
        <BlockUi tag="div" message="Loading, please wait" blocking={loginLoader} style={{ minHeight: 134 }} className="wallLoadingPage">
          <div className="slm-root slm-shell">
            {screens[state.screen] || screenLogin}
          </div>
        </BlockUi>
      </Dialog>
    </>
  );
}

export default withRouter(ServiceLoginModel);